import { InformationPopover } from '@/components/ui/InformationPopover/InformationPopover';
import React from 'react';

export interface SectionHeaderProps {
  title: React.ReactNode;
  info?: React.ReactNode;
  actions?: React.ReactNode;
}

export const SectionHeader: React.FC<SectionHeaderProps> = (props) => {
  const { title, info, actions } = props;
  return (
    <div className="mt-4 flex items-center justify-between border-gray-200 border-b pb-2">
      <div className="flex items-center justify-center">
        <h3 className="font-medium text-2xl text-gray-900 leading-6">
          {title}
        </h3>
        {info && (
          <InformationPopover>
            <span>{info}</span>
          </InformationPopover>
        )}
      </div>

      {actions}
    </div>
  );
};
